import { useTranslation } from 'react-i18next'
import { CompanyBusinessSettings, CompanySettingsForm } from '../components'
import { SettingsTitle } from '@/ui'
import { CompanyBuilding } from '@/icons'

export const CompanySettingsPage = () => {
  const { t } = useTranslation()
  return (
    <>
      <SettingsTitle
        icon={<CompanyBuilding size={36} />}
        title={t('company-settings.business-page.title')}
        description={t('company-settings.business-page.description')}
      />
      <CompanySettingsForm />
      <CompanyBusinessSettings />
    </>
  )
}
